import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { State } from "../../../redux/reducers/root";
import Button from "../button";
import PackcageNames from "../../packages/package-names";
import { checkoutPackages } from "../../../redux/actions/packages";
import { BUY_PACKAGES } from "../../../redux/constants/packages";
import { getSuccessActionType } from "../../../redux/utils";
import Dialog from "../dialog/dialog";

const PaymentModal = () => {
  const modalData = useSelector((state: State) => state.modals.data);
  const selectedPackage = modalData["packageType"];
  const packagePriceToman = modalData["packagePrice"] / 10;
  const taxPrice = ((modalData["packagePrice"] * 0.1) / 10000) * 1000;
  const [submited, setSubmited] = useState(false);
  const [buttonName, setButtonName] = useState("پرداخت امن بانکی");
  const [error, setError] = useState("");

  const dispatch = useDispatch();

  const handleSubmit = async () => {
    setSubmited(true);
    setButtonName("در حال انتقال به بانک");

    const res = await dispatch(
      checkoutPackages(parseInt(modalData["doctorId"]), selectedPackage, modalData["packageDuration"])
    );

    try {
      if (res.type === getSuccessActionType(BUY_PACKAGES)) {
        const payload = res.payload as unknown as { url: string };

        window.location.href = payload.url;

        setError("");
      }
    } catch (err) {
      setError("true");
      setSubmited(false);
      setButtonName("پرداخت امن بانکی");
    }
  };
  return (
    <div>
      {error === "true" && (
        <Dialog className="overflow-hidden rounded-3xl" show={true} onClose={() => setError("")}>
          <p className="flex items-center h-16 pr-8 "> عملیات پرداخت با خطا مواجه شد!</p>
          <Button onClick={close} type="button" variant="contained" className="w-full !rounded-none">
            بازگشت
          </Button>
        </Dialog>
      )}
      <div className="grid grid-cols-2 px-3 pt-3 pb-5">
        <div className="col-span-1 text-sm ">{`${PackcageNames[selectedPackage as keyof typeof PackcageNames]}  ${
          modalData["packageDuration"]
        } ماهه`}</div>
        <div className="col-span-1 ">
          <span className="float-left text-xs"> تومان</span>
          <span className="float-left pl-1 text-base font-medium">{packagePriceToman.toLocaleString()}</span>
        </div>
      </div>
      <div className="grid grid-cols-2 px-3 pb-3">
        <div className="col-span-1 text-sm ">مالیات بر ارزش افزوده</div>
        <div className="col-span-1 ">
          <span className="float-left text-xs"> تومان</span>
          <span className="float-left pl-1 text-base font-medium">{taxPrice.toLocaleString()}</span>
        </div>
      </div>
      <hr />
      <div className="grid grid-cols-2 p-3 text-blue-900">
        <div className="col-span-1 text-sm font-bold ">مجموع قابل پرداخت</div>
        <div className="col-span-1 ">
          <span className="float-left text-xs"> تومان</span>
          <span className="float-left pl-1 text-base font-medium">
            {(packagePriceToman + taxPrice).toLocaleString()}
          </span>
        </div>
      </div>
      <div className="flex">
        <Button
          variant="contained"
          className="w-full rounded-md"
          onClick={handleSubmit}
          disabled={submited}
          loading={submited}
        >
          {buttonName}
        </Button>
      </div>
    </div>
  );
};
export default PaymentModal;
